<template>

    <div class="ES-xcx-box" :ref="objloading">
        <div class="ES-xcx-banner" v-if="bannerlists.length > 0">
            <el-carousel height="150px">
            <el-carousel-item v-for="(item,index) in bannerlists" :key="index">
            <el-image fit="cover" :src="item.thumb" />
            </el-carousel-item>
            </el-carousel>
        </div>
        <div class="ES-xcx-cates" v-if="catelists.length > 0">
        <div class="ES-xcx-cates-info top20" v-for="(item,index) in catelists" :key="index">
        <el-image :src="item.thumb" fit="cover" />
        <span class="ES-xcx-cates-title">{{item.name}}</span>
        </div> 
        </div>
        <div class="ES-xcx-goods-nav top10" v-if="navilists.length > 0">
        <div class="ES-xcx-goods-box" :style="'width:'+navilists.length * 80 +'px'">
            <div :class="item.isselect ? 'ES-xcx-goods-navinfo nav-select' : 'ES-xcx-goods-navinfo' " v-for="(item,index) in navilists" :key="index">{{item.name}}</div>
        </div>
        </div>
        <div class="ES-xcx-goods top10">
            <div class="ES-xcx-goods-info" v-for="(item,index) in goodslists" :key="index">
            <el-image :src="item.thumb" fit="cover" class="ES-xcx-goods-thumb" />
            <span class="ES-xcx-goods-title top10">{{item.name}}</span>
            <span class="ES-xcx-goods-price">￥<h>{{item.price}}</h></span>
            </div>
        </div>
    </div>

</template>

<script>
import INTERFACE_XCX from '@/Interface/Es/xcx'; //小程序首页显示
export default {
    props:['banner','cates','navs'],
    components:{},

    data() {
        return {
            objloading:'xcxshow',
            bannerlists:[],
            catelists:[],
            navilists:[],
            goodslists:[
                {id:1,name:'这是一个二手货商品',price:200,thumb:require('@/assets/Goods/goods1.png')},
                {id:2,name:'这是一个二手货商品',price:200,thumb:require('@/assets/Goods/goods1.png')},
                {id:3,name:'这是一个二手货商品',price:200,thumb:require('@/assets/Goods/goods1.png')},
                {id:4,name:'这是一个二手货商品',price:200,thumb:require('@/assets/Goods/goods1.png')}
            ],

        }
    },

    mounted() {
        this.GetShowList();
    },

    watch: {
        banner(val) {
            if(val) this.bannerlists=this.banner;
        },
        cates(val) {
            if(val) this.catelists=this.cates;
        },
        navs(val) {
            if(val) {
                this.navilists=this.navs;
                if(this.navilists.length > 0) this.navilists[0].isselect=true;
            }
        },
    },

    methods: {

        //获取首页展示信息详情
        GetShowList() {
            INTERFACE_XCX.GET_SHOW_LIST().then((res) => {
                 if(res.status > 0) return false;
                 this.bannerlists=res.data.banner;
                 this.catelists=res.data.cates;
                 this.navilists=res.data.navs;
                 if(this.navilists.length > 0) this.navilists[0].isselect=true;
            });
        },

    },
    
}
</script>
<style scoped>
::-webkit-scrollbar {width:0;}
.ES-left {position:absolute;top:0;left:0;width:calc(30% - 40px);height: calc(100% - 40px);padding:20px;overflow-y: auto;font-size: 0;}
.ES-xcx-box {display: inline-block;width:calc(100% - 2px);height: calc(100% - 2px);overflow-y: auto;border:1px solid #E6E8EB;background-color: #FAFCFF;}
.ES-xcx-banner {display: inline-block;width:100%;height: 150px;background-color: #F5F7FA;}
.ES-xcx-banner .el-image {width:100%;height: 100%;}
::v-deep(.el-carousel__button) {width:10px;height: 10px;border-radius: 50%;opacity: 1;}
::v-deep(.ES-xcx-box .is-active .el-carousel__button) {background-color: #666eeb;}
.ES-xcx-cates {display: inline-block;width:100%;background-color: #ffffff;padding:0 0 20px 0;}
.ES-xcx-cates-info {display: inline-block;width:20%;text-align: center;}
.ES-xcx-cates-info .el-image {width:35px;height:35px;}
.ES-xcx-cates-title {display: inline-block;width:100%;font-size:12px;letter-spacing: 1px;text-align: center;color:#666666;margin-top:5px;}
.ES-xcx-goods-nav {display: inline-block;position:relative;width:100%;height: 58px;background-color: #ffffff;overflow-x:auto;}
.ES-xcx-goods-box {display:inline-block;position:absolute;left:0;top:0;margin-left:20px;margin-top:10px;}
.ES-xcx-goods-navinfo {width:80px;text-align: center;font-size: 13px;color:#CDD0D6;display: inline-block;border-bottom:1px solid #ffffff;padding:7px 0;}
.nav-select {color:#333333;border-bottom:1px solid #333333;}
.ES-xcx-goods {display: inline-block;padding:0 10px;width:calc(100% - 20px);}
.ES-xcx-goods-info {display: inline-block;width:calc(50% - 5px);padding:0 0 10px 0;overflow:hidden;border-radius: 15px;background-color: #ffffff;margin-bottom:10px;}
.ES-xcx-goods-info:nth-of-type(even) {margin-left:10px;}
.ES-xcx-goods-thumb {display: inline-block;width:100%;height: 120px;}
.ES-xcx-goods-title {display:inline-block;width:calc(100% - 20px);padding:0 10px;font-size:12px;color:#666666;}
.ES-xcx-goods-price {display:inline-block;width:calc(100% - 20px);padding:0 10px;font-size:12px;color:#ef5668;margin-top:7px;}
.ES-xcx-goods-price h {font-size:14px;font-weight: 600;}
</style>